"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessRegistrationResponseMapper = void 0;
var ProcessRegistrationResponseMapper = /** @class */ (function () {
    function ProcessRegistrationResponseMapper(data) {
        this.localData = data;
    }
    ProcessRegistrationResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return ProcessRegistrationResponseMapper;
}());
exports.ProcessRegistrationResponseMapper = ProcessRegistrationResponseMapper;
//# sourceMappingURL=ProcessRegistrationResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/ProcessRegistrationResponseMapper.js
// module id = 1968
// module chunks = 8